import "./dashboard-sections.css";

const DUMMY = {
  kg_prime_total: 41000,
  kg_prime_pct:   72,
  kg_per_case:    18.5,
};

const YieldEfficiency = ({ data = DUMMY, isLoading = false }) => (
  <div className="cmn_card ye-card">
    {/* Header with badge */}
    <div className="ye-header">
      <div className="ye-header-left">
        <span className="ye-icon">📈</span>
        <span className="ye-title">YIELD &amp; EFFICIENCY</span>
      </div>
      <span className="ye-prime-badge">KG Prime % {data.kg_prime_pct}</span>
    </div>

    <div className="ye-body">
      {/* Row 1: KG Prime Total + KG Prime % side by side */}
      <div className="ye-main-row">
        <div className="ye-main-col">
          <div className="ye-label">KG PRIME TOTAL</div>
          <div className="ye-value">
            {data.kg_prime_total?.toLocaleString()}
            <span className="db-metric-unit"> kg</span>
          </div>
        </div>
        <div className="ye-main-col ye-pct-col">
          <div className="ye-label">KG PRIME %</div>
          <div className="ye-pct">{data.kg_prime_pct}% <span className="ye-arrow">↑</span></div>
        </div>
      </div>

      <div className="ye-divider" />

      {/* Row 2: KG / Case */}
      <div>
        <div className="ye-label">KG / CASE</div>
        <div className="ye-value">
          {data.kg_per_case}
          <span className="db-metric-unit"> kg</span>
        </div>
      </div>
    </div>
  </div>
);

export default YieldEfficiency;
